//! Slider componente reutilizado de v1
import { Slider } from "../../kitSocialV2/components/slider.component";
import { KitListHeader } from "./kit-list-header.component";

export default function KitImgList({ category, images }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem" }}>
      <KitListHeader category={category} images={images} />
      <Slider images={images} downloadText={"Descargar"} />
    </div>
  );
}
